import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
import translator from "./translatorRouter";

Vue.use(VueRouter)

const routes = [
    // 完善个人资料
    {
        path: '/improve_information',
        component: resolve => require(['@/layouts/default'], resolve),
        children:[
            {
                path:"",
                name:"improve_information",
                component: () => import('../views/ImproveInformation.vue'),
                meta: {title: "完善信息", pageName: true}
            },
        ]
    },
    {
        path: '/modify_information',
        component: resolve => require(['@/layouts/default'], resolve),
        children:[
            {
                path:"",
                name:"modify_information",
                component: () => import('../views/modifyInformation.vue'),
                meta: {title: "修改信息", pageName: true}
            },

        ]
    },
    // 首页
    {
        path: "/",
        redirect: '/translator',
    },
    // 个人主页
    {
        path: "/translator",
        redirect: '/translator/index',
        component:resolve => require(['@/layouts/translator'], resolve),
        children: translator
    },
    // 翻译任务
    {
        path: "/translation_task",
        redirect: '/translation_task/accept',
        component:resolve => require(['@/layouts/translation_job'], resolve),
        children: [
            {
                path: "accept",
                name:"translation_task_accept",
                component:()=>import('@/views/translationTask/accept'),
                meta:{title: "接收翻译任务", pageName: true,  keepAlive: true, active: "translation_task"}
            },
            {
                path: "submit",
                name:"translation_task_submit",
                component:()=>import('@/views/translationTask/submit'),
                meta:{title: "提交翻译任务", pageName: true,  keepAlive: true, active: "translation_task"}
            },
        ]
    },
    // 翻译任务详情
    {
        path: "/translation_task",
        redirect: '/translation_task/accept',
        component:resolve => require(['@/layouts/translator'], resolve),
        children: [
            {
                path: "detail",
                name:"translation_task_detail",
                component:()=>import('@/views/translationTask/taskDetail'),
                meta:{title: "翻译任务详情", pageName: true, active: "translation_task"}
            },
        ]
    },

    // 审校任务
    {
        path: "/review_task",
        redirect: '/review_task/accept',
        component:resolve => require(['@/layouts/translation_job'], resolve),
        children: [
            {
                path: "accept",
                name:"review_task_accept",
                component:()=>import('@/views/reviewTask/accept'),
                meta:{title: "接收审校任务", pageName: true,  keepAlive: true, active: "review_task"}
            },
            {
                path: "submit",
                name:"review_task_submit",
                component:()=>import('@/views/reviewTask/submit'),
                meta:{title: "提交审校任务", pageName: true, keepAlive: true, active: "review_task"}
            },
        ]
    },
    // 审校任务详情
    {
        path: "/review_task",
        redirect: '/review_task/accept',
        component:resolve => require(['@/layouts/translator'], resolve),
        children: [
            {
                path: "detail",
                name:"review_task_detail",
                component:()=>import('@/views/reviewTask/taskDetail'),
                meta:{title: "审校任务详情", pageName: true, active: "review_task"}
            },
        ]
    },

    // 统稿任务
    {
        path: "/draft_task",
        redirect: '/draft_task/submit',
        component:resolve => require(['@/layouts/translator'], resolve),
        children: [
            {
                path: "submit",
                name:"draft_task_submit",
                component:()=>import('@/views/draftTask/submit'),
                meta:{title: "统稿任务", pageName: true,  keepAlive: true, active: "draft_task"}
            },
            {
                path: "detail",
                name:"draft_task_detail",
                component:()=>import('@/views/draftTask/taskDetail'),
                meta:{title: "统稿任务详情", pageName: true, active: "draft_task"}
            },
        ]
    },


    // 任务记录
    {
        path: "/task_record",
        component:resolve => require(['@/layouts/translator'], resolve),
        children: [
            {
                path: "",
                name:"task_record",
                component:()=>import('@/views/taskRecord/index'),
                meta:{title: "任务记录", pageName: true,  keepAlive: true, active: "task_record"}
            },
        ]
    },


    // 404 not found
    {path: "*", component: resolve => require(["@/views/errorPage"], resolve), meta: {title: 'error page'}},
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})





export default router
